import { render, staticRenderFns } from "./EmailTemplateEditComponent.vue?vue&type=template&id=3c416fe8&scoped=true&"
import script from "./EmailTemplateEditComponent.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateEditComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateEditComponent.vue?vue&type=style&index=0&id=3c416fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c416fe8",
  null
  
)

export default component.exports